module.exports = __webpack_public_path__ + "static/enlarged-prostate-5baf9a43177bb58e4a8eeb6f5c9e268e.svg";